/* WizardExecutionViewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./WizardExecutionViewRenderer");

class WizardExecutionViewComponent extends EventEmitter {
    constructor(logger, userFeedback, gameEditor, titleComponent, jnibAdapter, userSession) {
        super();
        this._logger = logger;
        this._userFeedback = userFeedback;
        this._gameEditor = gameEditor;
        this._gameEditorTitleCmpnt = titleComponent;
        this._jnibAdapter = jnibAdapter;
        this._userSession = userSession;

        this._gameEditorState = this._gameEditor.getEditorState();
        this._wizardJNIB = this._gameEditorState.ref;
        this._wizardEntity = this._gameEditorState.wizardEntity;
        this._startObj = this._gameEditorState.startObj;

        this._initializingProm = undefined;
        this._refLaunchState = true;
        this._registerListeners();
        this._init();
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {
        this._jnibAdapter.on(
            "ContinuationStarted",
            (this._onContinuationStarted = this._onContinuationStarted.bind(this))
        );
        this._jnibAdapter.on(
            "ContinuationFinished",
            (this._onContinuationFinished = this._onContinuationFinished.bind(this))
        );
    }
    _unregisterListeners() {
        this._jnibAdapter.removeListener("ContinuationStarted", this._onContinuationStarted);
        this._jnibAdapter.removeListener("ContinuationFinished", this._onContinuationFinished);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onContinuationStarted(eventData) {
        let continuation = eventData.continuation;
        let startObj = eventData.startObj;
        if (this._isThisOurContinuation(continuation)) {
            this.emit("ContinuationStarted", startObj);
        }
    }
    _onContinuationFinished(eventData) {
        let continuation = eventData.continuation;
        let finishObj = eventData.finishObj;
        if (this._isThisOurContinuation(continuation)) {
            this.emit("ContinuationFinished", finishObj);
        }
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _init() {
        this._initializingProm = new Promise((resolve /*,reject*/) => {
            this.on("WizardFormRunChanged", () => {
                resolve();
            });
            this._jnibAdapter._nibMgr.pmRunNIB(this._wizardJNIB, this._startObj, (ackData) => {
                ackData.continuation.jobEntity = this._wizardEntity;
                this._setContinuation(ackData.continuation);
            });
        });
    }
    _isThisOurContinuation(contn) {
        let answer = false;
        try {
            if (this.continuation.getId() === contn.getId()) {
                answer = true;
            }
        } catch (e) {
            /*gobble-gobble*/
        }
        return answer;
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    whenReady() {
        return this._initializingProm;
    }
    get gameEditor() {
        return this._gameEditor;
    }
    get continuation() {
        return this.getContinuation();
    }
    getContinuation() {
        return this._continuation;
    }
    _setContinuation(cntn, silent) {
        let old = this._continuation;
        this._continuation = cntn;
        if (!silent) {
            this.emit("ContinuationChanged", this._continuation, old);
        }
        return this;
    }
    get wizardFormRun() {
        return this.getWizardFormRun();
    }
    getWizardFormRun() {
        return this._wizardFormRun;
    }
    _setWizardFormRun(wfr, silent) {
        this._wizardFormRun = wfr;
        if (!silent) {
            this.emit("WizardFormRunChanged", this._wizardFormRun);
        }
        return this;
    }

    getUserFeedback() {
        return this._userFeedback;
    }

    get userFeedback() {
        return this.getUserFeedback();
    }

    /**
     * Check if the component has been cancelled.
     */
    isCancelled() {
        return this._cancelled;
    }

    /**
     * Set the components cancelled status.
     * @param flag
     */
    setCancelled(flag) {
        this._cancelled = flag;
    }

    set cancelled(flag) {
        this.setCancelled(flag);
    }

    get cancelled() {
        return this.isCancelled();
    }

    /**
     * Determine if the wizard should react to a ref launch event.
     * @param state
     */
    setRefLaunchState(state) {
        if (this._refLaunchState !== state) {
            this._refLaunchState = state;
            this.emit("RefLaunchStateChanged");
        }
    }

    set refLaunchState(state) {
        this.setRefLaunchState(state);
    }

    /**
     * Get the state to determine if the wizard should react to RefLaunch events.
     *
     * @returns {boolean}
     */
    getRefLaunchState() {
        return this._refLaunchState;
    }

    get refLaunchState() {
        return this.getRefLaunchState();
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /* START WIZARD ADAPTER METHODS */
    //NOTE: These methods are called during a web_jnib_engine continuation and is started by calling (this._jnibAdapter._nibMgr.pmRunNIB) see above.
    /*******************************************/
    launchWizard(wizFormRun) {
        this._setWizardFormRun(wizFormRun);
    }
    clearWizard() {
        this._logger.info({}, "CLEAR WIZARD CALLED OOOOH BOY.");
    }

    /**
     * Start a page transition
     */
    startNIBProgress(progressObj) {
        this.emit("StartNIBProgress", progressObj);
    }

    setFinishButtonTitle(title) {
        this.emit("SetFinishButtonTitle", title);
    }

    /**
     * Stop the page transition
     * @param progressObj
     */
    stopNIBProgress(progressObj) {
        this.emit("StopNIBProgress", progressObj);
    }

    updateNIBProgress(progressObj) {
        this.emit("UpdateNIBProgress", progressObj);
    }
    /*******************************************/
    /* END WIZARD ADAPTER METHODS */
    /*******************************************/
}
module.exports = WizardExecutionViewComponent;
module.exports.$inject = [
    "$teve.logger",
    "$teve.ui.userFeedback",
    "gameEditor.gameEditor",
    "gameEditor.titleComponent",
    "$teve.jnibAdapter",
    "$teve.userSession",
];
module.exports.$displayDetails = {
    type: "View",
    name: "Workflow Execution",
    icon: "wizard.wizardEditor", //TODO need a wizard execution icon
    shown: false, //Until we have multiple views hide this guy
    title: "Workflow Execution",
    order: 1,
};
